import "./App.css";
import { BrowserRouter, NavLink, Route, Routes } from "react-router-dom";
import LandingPage from "./screen/LandingPage";
import Sidebar from "./component/Sidebar";
import ContactScreen from "./screen/ContactScreen";
import ProductList from "./screen/ProductList";
import ProductDetails from "./screen/ProductDetails";
import Dashboard from "./screen/dashboard/Dashboard";
import ProductListed from "./screen/dashboard/ProductListed";
import ProductCreateScreen from "./screen/dashboard/ProductCreateScreen";
import ProductEditScreen from "./screen/dashboard/ProductEditScreen";
import AboutUs from "./screen/AboutUs";
import LoginScreen from "./screen/LoginScreen";
import ForgetPassword from "./screen/ForgetPassword";
import RegisterPage from "./screen/RegisterPage";
import UserQueries from "./screen/dashboard/UserQueries";
import CustomerDetails from "./screen/dashboard/CustomerDetails";
import CategoryListed from "./screen/dashboard/CategoryListed";

function App() {
	return (
		<BrowserRouter>
			<div className="d-flex justify-content-center blumessa-nav">
				<img src="/images/logo/shop_logo.png" alt="Woolen Category" />
			</div>
			<div className="App grid-container">
				<header>
					<div className="app-title">
						<img
							src="/images/logo/shop_logo.png"
							alt="Woolen Category"
						/>
						<NavLink to="/">
							<span className="pl-3 app-title-text">
								BLUMEESSA
							</span>
						</NavLink>
					</div>
					<div className="cartIcon">
						<div className="hamburger">
							<Sidebar />
						</div>
					</div>
				</header>

				<main style={{ background: "#F0E9D9" }}>
					<Routes>
						<Route path="/" element={<LandingPage />} />
						<Route path="/contact" element={<ContactScreen />} />
						<Route path="/aboutus" element={<AboutUs />} />
						<Route path="/login" element={<LoginScreen />} />
						<Route path="/register" element={<RegisterPage />} />
						<Route
							path="/forgotpassword"
							element={<ForgetPassword />}
						/>
						<Route
							path="/categories/:id"
							element={<ProductList />}
						/>
						<Route
							path="/productdetails"
							element={<ProductDetails />}
						/>
						<Route path="/dashboard" element={<Dashboard />} />
						<Route
							path="/productlisted"
							element={<ProductListed />}
						/>
						<Route
							path="/productcreateview"
							element={<ProductCreateScreen />}
						/>
						<Route
							path="/product-edit/:category/:productId"
							element={<ProductEditScreen />}
						/>
						<Route
							path="/customerdetails"
							element={<CustomerDetails />}
						/>
						<Route
							path="/customerquery"
							element={<UserQueries />}
						/>
						<Route
							path="/categories"
							element={<CategoryListed />}
						/>
					</Routes>
				</main>

				<footer>© All rights reserved 2026</footer>
			</div>
		</BrowserRouter>
	);
}

export default App;
